import { formatPrice } from "./types";
import { BookingLanguage } from "@/types/booking";
import { useMarket } from "@/hooks/useMarket";

interface PriceDisplayProps {
  price: number;
  label: string;
  animatePrice?: boolean;
  className?: string;
  language?: BookingLanguage;
}

export const PriceDisplay = ({
  price,
  label,
  animatePrice,
  className = "",
}: PriceDisplayProps) => {
  const { market } = useMarket();
  const priceClasses = `text-lg font-semibold transition-opacity duration-500 whitespace-nowrap ${
    animatePrice ? "opacity-100" : "opacity-0"
  } ${className}`;

  return (
    <div className="flex justify-between items-center">
      <span className="font-medium">{label}</span>
      <span className={priceClasses}>{formatPrice(price, market)}</span>
    </div>
  );
};
